import { render, staticRenderFns } from "./MobileTextPanelMoreTools.vue?vue&type=template&id=3fc55964&scoped=true&"
import script from "./MobileTextPanelMoreTools.vue?vue&type=script&lang=js&"
export * from "./MobileTextPanelMoreTools.vue?vue&type=script&lang=js&"
import style0 from "./MobileTextPanelMoreTools.vue?vue&type=style&index=0&id=3fc55964&prod&lang=scss&"
import style1 from "./MobileTextPanelMoreTools.vue?vue&type=style&index=1&id=3fc55964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc55964",
  null
  
)

export default component.exports